module.exports = __webpack_public_path__ + "static/img/summitlabLogo.320f1e04.png";